import React from "react";
import "../ActiveSimulations/style.css";

export default ({ simulations }) => {
  return (
    <div className="simulation-list-wrapper">
      <h4 className="simulation-list-header">COMPLETED SIMULATIONS</h4>
      {simulations.length ? (
        <div className="simulation-table-wrapper">
          <table className="simulation-table">
            <thead>
              <tr className="simulation-table-header-row">
                <th>Zone</th>
                <th>Project</th>
                <th>Customer</th>
                <th>Order ID</th>
                <th>Destination</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              {simulations.map((simulation) => (
                <tr key={simulation.orderId}>
                  <td>{simulation.zone.name}</td>
                  <td>{simulation.project.name}</td>
                  <td>{simulation.customerName}</td>
                  <td>{simulation.orderId}</td>
                  <td>{simulation.zone.destinationId}</td>
                  <td>
                    {simulation.status.substring(0, 1).toUpperCase() +
                      simulation.status.substring(1)}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <h4 className="no-simulations-message">
          You don't have any completed simulations
        </h4>
      )}
    </div>
  );
};
